export default function Footer() {
  const quickLinks = [
    { label: "今日热榜", href: "#hot" },
    { label: "分类速递", href: "#feeds" },
    { label: "深度盘点", href: "#feature" },
    { label: "今日瓜历", href: "#timeline" },
    { label: "常见问题", href: "#faq" },
    { label: "关于我们", href: "#about" },
  ];

  const catLinks = ["娱乐瓜", "科技瓜", "社会瓜", "财经瓜", "文体瓜"];

  return (
    <footer className="w-full bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 pt-12 pb-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜网上 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">
                吃瓜<span className="text-primary-600">网上</span>
              </span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              全网今日热点与焦点话题聚合页。每天帮你把最新鲜的瓜端上桌，一个页面看遍今日吃瓜风向。
            </p>
            <p className="mt-3 text-xs text-foreground-500">内容仅供信息参考，请以官方与权威信源为准。</p>
          </div>

          <nav aria-label="快速导航">
            <h4 className="text-sm font-medium text-foreground-900">快速导航</h4>
            <ul className="mt-3 grid grid-cols-2 gap-2 text-sm text-foreground-600">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover:text-primary-700 transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容板块">
            <h4 className="text-sm font-medium text-foreground-900">内容板块</h4>
            <ul className="mt-3 space-y-2 text-sm text-foreground-600">
              {catLinks.map((c) => (
                <li key={c}>
                  <a href="#feeds" className="hover:text-primary-700 transition-colors">{c}</a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-medium text-foreground-900">联系我们</h4>
            <p className="mt-3 text-sm text-foreground-600">有任何线索或建议，欢迎随时与我们沟通：</p>
            <a href="mailto:chiguawang@example.com" className="mt-2 inline-flex items-center gap-2 text-sm text-primary-700 hover:underline">
              <i className="ri-mail-line" aria-hidden="true"></i>chiguawang@example.com
            </a>
            <p className="mt-4 text-sm font-medium text-foreground-800">
              <i className="ri-time-line mr-1.5" aria-hidden="true"></i>内容全天滚动更新
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 吃瓜网上 · 今日热点全网汇总</p>
          <a href="#top" className="inline-flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-700 transition-colors whitespace-nowrap">
            <i className="ri-arrow-up-line" aria-hidden="true"></i> 回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}